var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7667 8.75C10.1006 8.75 8.75 10.1006 8.75 11.7667V48.2332C8.75 49.8993 10.1006 51.2499 11.7667 51.2499H48.2333C49.8994 51.2499 51.25 49.8993 51.25 48.2332V11.7667C51.25 10.1006 49.8994 8.75 48.2333 8.75H11.7667ZM18.2893 21.9484C20.3255 21.9484 21.9762 20.2977 21.9762 18.2615C21.9762 16.2253 20.3255 14.5747 18.2893 14.5747C16.2531 14.5747 14.6024 16.2253 14.6024 18.2615C14.6024 20.2977 16.2531 21.9484 18.2893 21.9484ZM25.3527 24.6731H31.463V27.4723C31.463 27.4723 33.1211 24.156 37.6327 24.156C41.6571 24.156 44.991 26.1386 44.991 32.1815V44.9244H38.6589V33.7256C38.6589 30.1608 36.7558 29.7688 35.3055 29.7688C32.2958 29.7688 31.7806 32.3648 31.7806 34.1906V44.9244H25.3527V24.6731ZM21.5032 24.6731H15.0754V44.9244H21.5032V24.6731Z",
    fill: "#310C6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ad8fdd17cfc42e61407f1917b0490774.svg";
export { ForwardRef as ReactComponent };